import { useState } from 'react';
import ReactSpreadsheet, { type Matrix, type CellBase } from 'react-spreadsheet';
import { cn } from '../utils/cn';

export interface SpreadsheetProps<T extends CellBase = CellBase> {
  data: Matrix<T>;
  columnLabels?: string[];
  rowLabels?: string[];
  onChange?: (data: Matrix<T>) => void;
  className?: string;
  readOnly?: boolean;
}

export function Spreadsheet<T extends CellBase = CellBase>({
  data: controlledData,
  columnLabels,
  rowLabels,
  onChange,
  className,
  readOnly,
}: SpreadsheetProps<T>) {
  const [internal, setInternal] = useState<Matrix<T>>(controlledData);
  const data = onChange ? controlledData : internal;

  const handleChange = (next: Matrix<T>) => {
    if (readOnly) return;
    if (onChange) onChange(next);
    else setInternal(next);
  };

  return (
    <div className={cn('kss-spreadsheet overflow-auto rounded-md border border-[var(--color-border)] bg-[var(--color-bg-card)] p-2', className)}>
      <ReactSpreadsheet<T>
        data={data}
        columnLabels={columnLabels}
        rowLabels={rowLabels}
        onChange={handleChange}
      />
    </div>
  );
}

export default Spreadsheet;
